import React from 'react';
import { useSelector } from 'react-redux';
import MemberRow from './memberRow/index';

const MemberList = () => {
    const memberList = useSelector(state => state.members.memberList);
    return (
        <div className="app-main-content">
            {memberList.map((entry, index) => <MemberRow key={index} member={entry} /> )}
        </div>
    );
};

export default MemberList;


// WEBPACK FOOTER //
// ./components/Agile/member/memberList/index.js